import React from 'react';
import styles from './VendorSaleList.module.css';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import P from 'routes/vendorRe/containers/commons/P';
import {
    contentStart,
    saleFontSize1,
    saleMargin1,
    commonFontWeight700,
    contentCenter,
    infoBorderColor,
    salePadding1,
} from 'routes/vendorRe/constraint/constraints';

const VendorSaleList = ({ data }) => {
    // 

    // data가 없는 경우 처리
    if (!data) {
        return null;
    }

    return (
        <FlexChild>
            <div style={{ borderBottom: infoBorderColor, padding: salePadding1 }}>
                <div className={styles.saleListCont}>
                    <HorizontalFlex>
                        <FlexChild justifyContent={contentCenter}>
                            <img className={styles.liquid} src={data.productImg} alt='액상담배 썸네일' />
                        </FlexChild>
                        <FlexChild >
                            <VerticalFlex>
                                <FlexChild alignItems={contentStart}>
                                    <P size={"min(2.6vw, 20px)"} >{data.productName}</P>
                                    {
                                        data.price &&
                                        <P size={"min(2.6vw, 20px)"} >{data.price ? data.price.toLocaleString() : 0}</P>
                                    }

                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild  justifyContent={contentCenter}>
                            <P width size={"min(2.6vw, 20px)"} weight={commonFontWeight700}>{data.totalQuantity ? data.totalQuantity : data.quantity ? data.quantity : 0}</P>
                        </FlexChild>
                    </HorizontalFlex>
                </div>
            </div>
        </FlexChild>
    );
};

export default VendorSaleList;